#@import _
#@import Backbone
#@export Booking.Views.Base

class Booking.Views.Base extends Backbone.View

  module: 'booking'

  constructor: (@options = {}) ->
    _.extend(this, _.pick(@options, ['templateName', 'module', 'presenter', 'validationHandler']));
    Backbone.View.apply this, arguments
    _.bindAll this, 'beforeRender', 'render', 'afterRender'
    @render = _.wrap this.render, (render) =>
      @beforeRender()
      render()
      @afterRender()
      this

  beforeRender: -> #noop

  afterRender: -> #noop

  template: ->
    throw new Error "View is missing templateName" unless @templateName
    window.BookingTemplates["#{@module}_frontend_templates_#{@templateName}"]

  getPresenter: ->
    if @presenter
      @_presenter ?= new @presenter @options, @templateName
      @_presenter

  templateAttributes: ->
    if @presenter then @getPresenter().toHashWithHelpers() else @options

  toHtml: ->
    if @template()
      @template().render @templateAttributes()
    else
      errorMessage = "Error: Template Not Found (#{@module}_frontend_templates_#{@templateName})"
      return "<span style='color:red;'>#{errorMessage}</span>"

  render: ->
    @$el.html @toHtml()
    this

  bhw: (widget) ->
    @$el?.attr 'data-bhw', widget

  bhc: ($el, content) ->
    $el?.attr 'data-bhc', content

  translate: ->
    i18n = @getPresenter().getI18n()
    i18n.translate.apply(i18n, arguments)
